export default "__VITE_ASSET__Bu57OzwS__"